var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "sidebar-menu",
    staticStyle: {
      "border-bottom": "1px solid rgb(173, 180, 187)",
      "box-shadow": "rgb(243, 253, 255) 0px 1px 0px"
    }
  }, [_c('li', {
    staticClass: "header",
    staticStyle: {
      "color": "#999",
      "padding": "5px 0px 0px 5px",
      "margin": "5px 0px",
      "background-color": "inherit"
    }
  }, [_c('form', {
    staticClass: "sidebar-form row",
    style: ('margin-left:' + (_vm.right ? '10px' : '0px') + ';')
  }, [_c('div', {
    staticClass: "col-xs-10 sidebar-text",
    staticStyle: {
      "padding": "0px",
      "font-size": "larger"
    }
  }, [(_vm.idRoot != -1) ? _c('span', {
    attrs: {
      "id": "primo_span"
    }
  }, [_c('popover-alert', {
    attrs: {
      "effect": "fade",
      "placement": "bottom",
      "classes": "in_sidebar",
      "content": _vm.root_info,
      "id": 'popoup_in_sidebar',
      "popoverCondition": _vm.info_catalog,
      "popoverStyle": {
        'max-width': '200px',
        'width': '200px',
        'font-size': 'small',
        'height': '60px',
        'position': 'fixed'
      },
      "showOK": false,
      "showNO": false,
      "textStyle": {
        color: '#222'
      },
      "arrowStyle": {
        left: '6%',
        top: '-9px'
      }
    }
  }, [_c('i', {
    class: _vm.$root.catalog_icon,
    staticStyle: {
      "cursor": "pointer",
      "margin-right": "5px",
      "font-size": "1.1em"
    },
    attrs: {
      "id": "info_catalog",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.toggleCatInfo($event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "font-family": "'Source Sans Pro'",
      "display": "inline",
      "margin-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.desRoot))])])])], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.finding_target),
      expression: "!finding_target"
    }],
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "id": "sideOpen"
    }
  }, [(_vm.displaying.length > 0 && _vm.ready) ? _c('ul', {
    staticClass: "sidebar-menu",
    style: ('overflow-y:' + _vm.overflow + ';overflow-x: hidden; max-height:' + _vm.maxHeight + ';margin-left:' + (_vm.right ? '5px' : '0px') + ';'),
    attrs: {
      "id": "side-list"
    }
  }, _vm._l((_vm.displaying), function(item, index) {
    return _c('li', {
      staticClass: "pageLink"
    }, [_c('recursiveItem', {
      key: item.sid,
      attrs: {
        "item": item,
        "configs": _vm.merged_c
      },
      on: {
        "shrimp_build_path": _vm.EndShrimpBuildPath
      }
    })], 1)
  })) : _vm._e()]), _vm._v(" "), (_vm.finding_target) ? _c('div', {
    staticClass: "sk-cube-grid"
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9 loading-nav-waiter"
  })]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-119ce43c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 1384
// module chunks = 1